import Vue from 'vue'
import './utils/dict'
import App from './App.vue'
import router from './router'
import './permission'
import store from './store'
import elementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './styles/theme.css'
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

// 注册富文本编辑器
Vue.use(VueQuillEditor)

// 全局注册视频播放器组件（课时/课程视频预览弹窗）
import VideoPlayer from './components/common/videoPlayer'
Vue.component('video-player', VideoPlayer)


Vue.config.productionTip = false
Vue.use(elementUI)

// 设置浏览器标题
document.title = '青少年人工智能高水平创新人才培养 课程平台'

//EventBus事件中转
Vue.prototype.$bus = new Vue()

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
